define([
    './directives/DropdownDirective',
    './directives/DropdownToggleDirective'
], (DropdownDirective, DropdownToggleDirective)=> {
    return angular.module('edge.platform.widgets.dropdown', [])
        .directive('gwPlDropdown', DropdownDirective)
        .directive('gwDropdownToggle', DropdownToggleDirective);
});


/** WEBPACK FOOTER **
 ** ./common/js/src/edge/platform/widgets/dropdown/module.js
 **/